import { memo } from 'react';
import { getRandomNumberInRange } from '../lib/utils';

const AVATAR_COLOURS = ['#2849BC', '#E007FF', '#2360FF', '#1ABAFF', '#25E1A7'];

/**
 *
 * @returns This function generate gardient value for avatar and return translate string value
 */
const getTranslateValue = () => {
  const scale = getRandomNumberInRange(11, 15) / 10;
  const translateMainNum = getRandomNumberInRange(-359, 359);
  const t1 = getRandomNumberInRange(0, 9);
  const t2 = t1 * (getRandomNumberInRange(-100, 100) > 0 ? 1 : -1);
  return `translate(${t1} ${t2}) rotate(${translateMainNum} 40 40) scale(${scale})`;
};

export const BoringAvatar = memo(() => {
  const fill1 = AVATAR_COLOURS[getRandomNumberInRange(1, 3)];
  const fill2 =
    AVATAR_COLOURS[getRandomNumberInRange(0, AVATAR_COLOURS.length - 1)];
  const translate1 = getTranslateValue();
  const translate2 = getTranslateValue();
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      className="rounded-full"
      height="32">
      <g mask="url(#:r6j:)">
        <rect width="80" height="80" fill="#25e1a7"></rect>
        <path
          filter="url(#filter_:r6j:)"
          d="M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z"
          fill={fill1}
          transform={translate1}></path>
        <path
          filter="url(#filter_:r6j:)"
          d="M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z"
          fill={fill2}
          transform={translate2}
          style={{ mixBlendMode: 'overlay' }}></path>
      </g>
      <defs>
        <filter
          id="filter_:r6j:"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"></feBlend>
          <feGaussianBlur
            stdDeviation="7"
            result="effect1_foregroundBlur"></feGaussianBlur>
        </filter>
      </defs>
    </svg>
  );
});
